import React from 'react';
import Input from '../../UI/Input';
import Button from '../../UI/Button';

export default function SkillsForm({ skills = [], onChange }) {
	const items = skills || [];

	function addCategory() {
		onChange([...(items || []), { category: '', level: 'Intermediate', items: [] }]);
	}
	function removeCategory(i) {
		onChange(items.filter((_, idx) => idx !== i));
	}
	function updateCategory(i, key, value) {
		const next = [...items];
		next[i] = { ...next[i], [key]: value };
		onChange(next);
	}
	function addSkill(i, text) {
		const next = [...items];
		const list = Array.isArray(next[i].items) ? next[i].items : [];
		next[i].items = [...list, text];
		onChange(next);
	}
	function removeSkill(i, idx) {
		const next = [...items];
		next[i].items = (next[i].items || []).filter((_, k) => k !== idx);
		onChange(next);
	}

	return (
		<div className="space-y-4">
			{!items.length && <div className="text-sm text-gray-500">No skill categories yet.</div>}
			{items.map((cat, i) => (
				<div key={i} className="border rounded-md p-4 space-y-3">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
						<Input name={`category-${i}`} label="Category" value={cat.category || ''} onChange={(e) => updateCategory(i, 'category', e.target.value)} />
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Level</label>
							<select
								className="w-full rounded-md border border-gray-300 px-3 py-2"
								value={cat.level || 'Intermediate'}
								onChange={(e) => updateCategory(i, 'level', e.target.value)}
							>
								{['Beginner', 'Intermediate', 'Advanced', 'Expert'].map((lv) => (
									<option key={lv} value={lv}>
										{lv}
									</option>
								))}
							</select>
						</div>
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Add Skill</label>
							<AddOnEnter onAdd={(val) => addSkill(i, val)} placeholder="Type and press Enter" />
						</div>
					</div>
					<div className="flex flex-wrap gap-2">
						{(cat.items || []).map((s, idx) => (
							<span key={idx} className="px-2 py-0.5 bg-gray-100 rounded text-xs">
								{s}{' '}
								<button type="button" className="ml-1 text-red-600" onClick={() => removeSkill(i, idx)}>
									×
								</button>
							</span>
						))}
					</div>
					<div className="text-right">
						<Button variant="ghost" onClick={() => removeCategory(i)}>
							Remove Category
						</Button>
					</div>
				</div>
			))}
			<Button variant="ghost" onClick={addCategory}>
				Add Category
			</Button>
		</div>
	);
}

function AddOnEnter({ onAdd, placeholder }) {
	const [val, setVal] = React.useState('');
	function onKeyDown(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			if (!val.trim()) return;
			onAdd(val.trim());
			setVal('');
		}
	}
	return (
		<input
			className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
			placeholder={placeholder}
			value={val}
			onChange={(e) => setVal(e.target.value)}
			onKeyDown={onKeyDown}
		/>
	);
}


